export const proficiencyLevelsKeys = {
  all: () => ["proficiencyLevels"]
};
